import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'

import { SET_ACCOUNT } from 'store/account/action'
import { GET, POST, httpOk } from 'helpers/api'

function ProfileModal({ show, setShow }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const reduxAccount = useSelector(state => state.account)

	// Ответ /user-settings храним целиком: POST перезаписывает объект пользователя
	// полностью, поэтому settings нужно вернуть обратно нетронутыми
	const [source, setSource] = useState({})
	const [data, setData] = useState({ 'first_name': '', 'phone': '', 'password': '' })
	const [showPassword, setShowPassword] = useState(false)

	async function getUserSettings() {
		const response = await GET('/user-settings')
		if (!httpOk(response)) return

		setSource(response.data)
		setData({
			'first_name': response.data?.first_name ?? '',
			'phone': response.data?.phone ?? '',
			'password': '',
		})
	}

	async function saveProfile(e) {
		e.preventDefault()

		const response = await POST('/user-settings', { ...source, ...data }, { loader: true })
		if (!httpOk(response)) return

		dispatch(SET_ACCOUNT({ ...reduxAccount, 'first_name': data.first_name }))
		setShow(false)
	}

	useEffect(() => {
		if (show) {
			setShowPassword(false)
			getUserSettings()
		}
	}, [show]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Modal show={show} animation={false} centered onHide={() => setShow(false)}>
			<Modal.Header closeButton>
				<Modal.Title>{t('settings')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<form autoComplete="off" onSubmit={saveProfile}>
					<div className="form-group">
						<label>{t('name')}</label>
						<input type="text" className="form-control" name="first_name"
							autoComplete="off" autoFocus
							value={data.first_name}
							onChange={(e) => setData({ ...data, 'first_name': e.target.value })} />
					</div>
					<div className="form-group">
						<label>{t('phone')}</label>
						<input type="text" inputMode="numeric" className="form-control" name="phone"
							autoComplete="off"
							value={data.phone}
							onChange={(e) => setData({ ...data, 'phone': e.target.value.replace(/\D/g, '') })} />
					</div>
					<div className="form-group">
						<label>{t('new_password')}</label>
						<div className="input-group">
							<input type={showPassword ? 'text' : 'password'} className="form-control"
								name="password" autoComplete="new-password"
								placeholder={t('leave_empty_to_keep_current')}
								value={data.password}
								onChange={(e) => setData({ ...data, 'password': e.target.value })} />
							<button type="button" className="btn btn-outline-secondary"
								tabIndex={-1}
								title={showPassword ? t('hide_password') : t('show_password')}
								aria-label={showPassword ? t('hide_password') : t('show_password')}
								onClick={() => setShowPassword(!showPassword)}>
								<i className={`uil ${showPassword ? 'uil-eye-slash' : 'uil-eye'}`}></i>
							</button>
						</div>
					</div>
					<div className="d-flex gap-2 w-100">
						<button type="button" className="btn btn-warning w-100"
							onClick={() => setShow(false)}>
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100">
							{t('save')}
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	)
}

export default ProfileModal
